export class LocationExtension {
    public static get HOSTNAME() {
        return location.hostname === 'localhost' ? 'econtract.techlab.ai' : location.hostname;
        //hopdong-dev.vnptit3.vn
        //econtract-dev.vnptit3.vn
    }
}
